// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2sZuZ","label":"Radio_label__1WPOT","checkMark":"Radio_checkMark__Ijxbk","disabled":"Radio_disabled__1SJen"};